
import { Component, Prop, Vue } from "nuxt-property-decorator";
import PelletsComparisonBarWrapper from "~/components/organisms/display/pellets/PelletsComparisonBarWrapper.vue";
import ReducedPriceComparison from "~/components/organisms/form/ReducedPriceComparison.vue";
import { STANDARD_PELLETS_QUANTITY } from "~/types/Pellets";
import { PELLETS_AMOUNT_LIMITS } from "~/utils/pelletsSorte";

@Component({
  components: {
    PelletsComparisonBarWrapper,
    ReducedPriceComparison,
  },
})
export default class PelletsStickyComparisonBar extends Vue {
  @Prop({ required: true }) visible!: boolean;

  STANDARD_PELLETS_QUANTITY = STANDARD_PELLETS_QUANTITY;
  looseLimits = PELLETS_AMOUNT_LIMITS.loose;
}
